import { useEffect } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { Loader } from "@components";
import { useLocation } from "react-router-dom";
import { useLocalStorage, LocalStorageKey } from "@helpers/localStorageHelper";
import { LoginRedirect } from "@store/generalTypes";

export const Login = (): JSX.Element => {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [, setLoginRedirect] = useLocalStorage<LoginRedirect>(LocalStorageKey.LoginRedirect);
    const { pathname } = useLocation();

    useEffect(() => {
        const loginRedirect = async (): Promise<void> => {
            await instance.loginRedirect(loginRequest);
        };

        // force login for root page
        if (!isAuthenticated) {
            void loginRedirect();
            if (!pathname.includes("login")) {
                setLoginRedirect({ pathname });
            }
        }

        void loginRedirect();
    }, []);

    return <Loader />;
};

export default Login;
